"use client";

import { Button } from "./ui/button";

export default function ErrorComponent({
  reset,
  title = "Something went wrong",
  body = "We're sorry, but there was an error loading this page.",
  buttonText = "Try again",
}: { reset: () => void; title?: string; body?: string; buttonText?: string }) {
  return (
    <div className="flex flex-col items-center justify-center text-center h-full p-12">
      <h1 className="text-4xl font-bold mb-4">{title}</h1>
      <p className="text-lg mb-6">{body}</p>
      <Button
        onClick={() => reset()}
        className="text-white font-medium px-6 py-2 rounded transition-colors"
        type="button"
        variant="outline"
      >
        {buttonText}
      </Button>
    </div>
  );
}
